import React, { useState } from "react";
import styled from "styled-components";
import {
  Container,
  FormCard,
  FormTitle,
  FormField,
  Label,
  Input,
  TextArea,
  RadioGroup,
  RadioOption,
  FileUpload,
  FileList,
  FileItem,
  RemoveButton,
  ButtonGroup,
  CancelButton,
  CreateButton,
} from "./CreatePage/CreatePage.styles";
import { useNavigate } from "react-router-dom";
import { createProject } from "../api/ProjectAPI";

export default function ProjectCreatePage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    projectName: "",
    projectDescription: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await createProject(formData);
      navigate("/project");
    } catch (error) {
      console.error("프로젝트 생성 실패:", error);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Container>
      <FormCard>
        <FormTitle>프로젝트 매니저 생성</FormTitle>

        <form onSubmit={handleSubmit}>
          <FormField>
            <Label>프로젝트 매니저 이름</Label>
            <Input
              type="text"
              placeholder="프로젝트 이름을 입력하세요"
              value={formData.projectName}
              onChange={(e) => handleInputChange("projectName", e.target.value)}
              required
            />
          </FormField>

          <FormField>
            <Label>프로젝트 매니저 설명</Label>
            <TextArea
              placeholder="프로젝트에 대한 설명을 입력하세요"
              value={formData.projectDescription}
              onChange={(e) =>
                handleInputChange("projectDescription", e.target.value)
              }
              required
            />
          </FormField>

          <ButtonGroup>
            <CancelButton type="button" onClick={handleCancel}>
              취소
            </CancelButton>
            <CreateButton type="submit">생성</CreateButton>
          </ButtonGroup>
        </form>
      </FormCard>
    </Container>
  );
}
